import { AUTH_LOGOUT } from '@/store/actions/auth';
import {
  STORE_PATIENT_FILTERS,
  CLEAR_PATIENT_FILTERS,
} from '@/store/actions/patientFilters';

const PATIENT_FILTERS_KEY = 'PATIENT_FILTERS';

const actions = {
  [STORE_PATIENT_FILTERS]: ({ commit }, filters) => {
    localStorage.setItem(PATIENT_FILTERS_KEY, JSON.stringify(filters));
    commit(STORE_PATIENT_FILTERS, filters);
  },
  [CLEAR_PATIENT_FILTERS]: ({ commit }) => {
    localStorage.removeItem(PATIENT_FILTERS_KEY);
    commit(CLEAR_PATIENT_FILTERS);
  },
};

const getters = {
  isNeedConfirmPatientFilters: (state) => state.filters !== null,
  getPatientFilters: (state) => state.filters,
};

const mutations = {
  [STORE_PATIENT_FILTERS]: (state, filters) => {
    state.filters = filters;
  },
  [CLEAR_PATIENT_FILTERS]: (state) => {
    state.filters = null;
  },
  [AUTH_LOGOUT]: (state) => {
    state.filters = null;
  },
};

const state = () => ({
  filters: null,
});

export default () => ({
  actions,
  getters,
  mutations,
  state,
});
